// "How to play Spades" — the rules exactly as the games function plays them
// (supabase/functions/games/spades.ts). Shared by the on-screen guide and the
// VR rules panel, so the two can't drift apart.

/** External video walkthrough (Gather Together Games, covers nil and bags). */
export const SPADES_TUTORIAL_URL = 'https://www.youtube.com/watch?v=HmxpLGjZ5sQ';
export const SPADES_TUTORIAL_TITLE = 'How To Play Spades (4 Player) — Gather Together Games';

export const SPADES_RULES: { title: string; lines: string[] }[] = [
  {
    title: 'Teams',
    lines: [
      'Four players, two teams. Partners sit across from each other: North & South vs East & West.',
      'Each hand, all 52 cards are dealt — 13 each.',
    ],
  },
  {
    title: 'Bidding',
    lines: [
      'Everyone bids how many tricks they expect to win (0–13). Your bid and your partner\'s add up to your team\'s contract.',
      'Nil (0) means you promise to win no tricks at all. Blind nil isn\'t used.',
    ],
  },
  {
    title: 'Playing a trick',
    lines: [
      'The player left of the dealer leads. Everyone must follow the suit that was led if they can.',
      'Can\'t follow? Play anything — a spade trumps the trick.',
      'The highest spade wins; with no spades, the highest card of the suit led wins. The winner leads next.',
      'Spades can\'t be led until one has been played on another suit ("broken"), unless you hold only spades.',
    ],
  },
  {
    title: 'Scoring',
    lines: [
      'Make your contract: 10 points per trick bid, plus 1 point per extra trick (a "bag").',
      'Miss it ("set"): minus 10 points per trick bid.',
      'Nil: +100 if the nil bidder wins no tricks, −100 if they win any — and those tricks count as bags. A nil bidder\'s tricks never count toward the partner\'s contract.',
      'Every 10 bags costs your team 100 points.',
    ],
  },
  {
    title: 'Winning',
    lines: [
      'First team to 500 wins (a tie keeps playing).',
      'A team that falls to −200 loses.',
    ],
  },
];
